import {
  FILTER_TYPES,
  ReportFilterConfigBase,
} from "../../filters/config/types";
import { BASE_DATE_RANGE_PRESETS, METRIC_PRESETS, MetricFilter, PIVOT_DATE_RANGE_PRESETS } from "../common/filters";

export const Filters: ReportFilterConfigBase[] = [
  {
    label: "Client",
    type: FILTER_TYPES.Client,
    fields: "client_ids",
    flexBasis: 240,
    isMulti: true,
  },
  {
    label: "Range 1",
    type: FILTER_TYPES.DateRange,
    fields: ["category_date_range_1", "start_date_range_1", "end_date_range_1"],
    defaultValue: ["", "", ""],
    presets: BASE_DATE_RANGE_PRESETS,
  },
  {
    label: "Range 2",
    type: FILTER_TYPES.DateRange,
    fields: ["category_date_range_2", "start_date_range_2", "end_date_range_2"],
    defaultValue: ["", "", ""],
    dependsOn: {
      filterFields: [
        "category_date_range_1",
        "start_date_range_1",
        "end_date_range_1",
      ],
    },
    presets: BASE_DATE_RANGE_PRESETS,
    presetPivots: PIVOT_DATE_RANGE_PRESETS,
  },
  {
    label: "Client Tag",
    type: FILTER_TYPES.ClientTag,
    fields: "client_tags",
  },
  {
    label: "Client Status",
    type: FILTER_TYPES.AccountStatus,
    fields: "account_status_id",
    dropdownOptionsFilter: {
      company_type: "CLIENT",
    },
    flexBasis: 150,
  },
  {
    label: "Metric",
    fields: "metric_type",
    type: FILTER_TYPES.Switch,
    defaultValue: MetricFilter.Total,
    options: METRIC_PRESETS,
    flexBasis: 400,
  },
];
